module.exports = new __parcel__URL__("gpoy.40c0d905.jpg").toString();